import { render, staticRenderFns } from "./AgentCommissionRoundDetail.vue?vue&type=template&id=51b33096&"
import script from "./AgentCommissionRoundDetail.vue?vue&type=script&lang=js&"
export * from "./AgentCommissionRoundDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports